/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GmModelLibraryModelsContractsContractModel } from '../model';
// @ts-ignore
import { GmModelLibraryModelsQuotesQuoteModel } from '../model';
// @ts-ignore
import { GmModelLibraryModelsQuotesQuoteRejectionModel } from '../model';
/**
 * QuoteApi - axios parameter creator
 * @export
 */
export const QuoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Register a sent quote as accepted.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteAcceptQuote: async (quoteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('quoteAcceptQuote', 'quoteId', quoteId)
            const localVarPath = `/v1/quotes/{quoteId}/accept`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a contract draft from an accepted quote. Not implemented yet: always returns 501.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteCreateContractFromQuote: async (quoteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('quoteCreateContractFromQuote', 'quoteId', quoteId)
            const localVarPath = `/v1/quotes/{quoteId}/create-contract`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a quote.
         * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteCreateQuote: async (gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmModelLibraryModelsQuotesQuoteModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a quote by id.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteGetQuote: async (quoteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('quoteGetQuote', 'quoteId', quoteId)
            const localVarPath = `/v1/quotes/{quoteId}`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The quote document as PDF. Not implemented yet: always returns 501.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteGetQuotePdf: async (quoteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('quoteGetQuotePdf', 'quoteId', quoteId)
            const localVarPath = `/v1/quotes/{quoteId}/pdf`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a sent quote as rejected, with a reason.
         * @param {string} quoteId 
         * @param {GmModelLibraryModelsQuotesQuoteRejectionModel} [gmModelLibraryModelsQuotesQuoteRejectionModel] The reason, and a description when the reason is Other
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteRejectQuote: async (quoteId: string, gmModelLibraryModelsQuotesQuoteRejectionModel?: GmModelLibraryModelsQuotesQuoteRejectionModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('quoteRejectQuote', 'quoteId', quoteId)
            const localVarPath = `/v1/quotes/{quoteId}/reject`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmModelLibraryModelsQuotesQuoteRejectionModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a quote.
         * @param {string} quoteId 
         * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteUpdateQuote: async (quoteId: string, gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('quoteUpdateQuote', 'quoteId', quoteId)
            const localVarPath = `/v1/quotes/{quoteId}`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmModelLibraryModelsQuotesQuoteModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuoteApi - functional programming interface
 * @export
 */
export const QuoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Register a sent quote as accepted.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteAcceptQuote(quoteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsQuotesQuoteModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteAcceptQuote(quoteId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteAcceptQuote']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a contract draft from an accepted quote. Not implemented yet: always returns 501.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteCreateContractFromQuote(quoteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsContractsContractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteCreateContractFromQuote(quoteId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteCreateContractFromQuote']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a quote.
         * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteCreateQuote(gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsQuotesQuoteModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteCreateQuote(gmModelLibraryModelsQuotesQuoteModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteCreateQuote']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a quote by id.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteGetQuote(quoteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsQuotesQuoteModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteGetQuote(quoteId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteGetQuote']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary The quote document as PDF. Not implemented yet: always returns 501.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteGetQuotePdf(quoteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteGetQuotePdf(quoteId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteGetQuotePdf']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Register a sent quote as rejected, with a reason.
         * @param {string} quoteId 
         * @param {GmModelLibraryModelsQuotesQuoteRejectionModel} [gmModelLibraryModelsQuotesQuoteRejectionModel] The reason, and a description when the reason is Other
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteRejectQuote(quoteId: string, gmModelLibraryModelsQuotesQuoteRejectionModel?: GmModelLibraryModelsQuotesQuoteRejectionModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsQuotesQuoteModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteRejectQuote(quoteId, gmModelLibraryModelsQuotesQuoteRejectionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteRejectQuote']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a quote.
         * @param {string} quoteId 
         * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteUpdateQuote(quoteId: string, gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsQuotesQuoteModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteUpdateQuote(quoteId, gmModelLibraryModelsQuotesQuoteModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['QuoteApi.quoteUpdateQuote']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * QuoteApi - factory interface
 * @export
 */
export const QuoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuoteApiFp(configuration)
    return {
        /**
         * 
         * @summary Register a sent quote as accepted.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteAcceptQuote(quoteId: string, options?: any): AxiosPromise<GmModelLibraryModelsQuotesQuoteModel> {
            return localVarFp.quoteAcceptQuote(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a contract draft from an accepted quote. Not implemented yet: always returns 501.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteCreateContractFromQuote(quoteId: string, options?: any): AxiosPromise<GmModelLibraryModelsContractsContractModel> {
            return localVarFp.quoteCreateContractFromQuote(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a quote.
         * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteCreateQuote(gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options?: any): AxiosPromise<GmModelLibraryModelsQuotesQuoteModel> {
            return localVarFp.quoteCreateQuote(gmModelLibraryModelsQuotesQuoteModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a quote by id.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteGetQuote(quoteId: string, options?: any): AxiosPromise<GmModelLibraryModelsQuotesQuoteModel> {
            return localVarFp.quoteGetQuote(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The quote document as PDF. Not implemented yet: always returns 501.
         * @param {string} quoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteGetQuotePdf(quoteId: string, options?: any): AxiosPromise<void> {
            return localVarFp.quoteGetQuotePdf(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a sent quote as rejected, with a reason.
         * @param {string} quoteId 
         * @param {GmModelLibraryModelsQuotesQuoteRejectionModel} [gmModelLibraryModelsQuotesQuoteRejectionModel] The reason, and a description when the reason is Other
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteRejectQuote(quoteId: string, gmModelLibraryModelsQuotesQuoteRejectionModel?: GmModelLibraryModelsQuotesQuoteRejectionModel, options?: any): AxiosPromise<GmModelLibraryModelsQuotesQuoteModel> {
            return localVarFp.quoteRejectQuote(quoteId, gmModelLibraryModelsQuotesQuoteRejectionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a quote.
         * @param {string} quoteId 
         * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteUpdateQuote(quoteId: string, gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options?: any): AxiosPromise<GmModelLibraryModelsQuotesQuoteModel> {
            return localVarFp.quoteUpdateQuote(quoteId, gmModelLibraryModelsQuotesQuoteModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuoteApi - object-oriented interface
 * @export
 * @class QuoteApi
 * @extends {BaseAPI}
 */
export class QuoteApi extends BaseAPI {
    /**
     * 
     * @summary Register a sent quote as accepted.
     * @param {string} quoteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteAcceptQuote(quoteId: string, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteAcceptQuote(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a contract draft from an accepted quote. Not implemented yet: always returns 501.
     * @param {string} quoteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteCreateContractFromQuote(quoteId: string, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteCreateContractFromQuote(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a quote.
     * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteCreateQuote(gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteCreateQuote(gmModelLibraryModelsQuotesQuoteModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a quote by id.
     * @param {string} quoteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteGetQuote(quoteId: string, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteGetQuote(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The quote document as PDF. Not implemented yet: always returns 501.
     * @param {string} quoteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteGetQuotePdf(quoteId: string, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteGetQuotePdf(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a sent quote as rejected, with a reason.
     * @param {string} quoteId 
     * @param {GmModelLibraryModelsQuotesQuoteRejectionModel} [gmModelLibraryModelsQuotesQuoteRejectionModel] The reason, and a description when the reason is Other
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteRejectQuote(quoteId: string, gmModelLibraryModelsQuotesQuoteRejectionModel?: GmModelLibraryModelsQuotesQuoteRejectionModel, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteRejectQuote(quoteId, gmModelLibraryModelsQuotesQuoteRejectionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a quote.
     * @param {string} quoteId 
     * @param {GmModelLibraryModelsQuotesQuoteModel} [gmModelLibraryModelsQuotesQuoteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public quoteUpdateQuote(quoteId: string, gmModelLibraryModelsQuotesQuoteModel?: GmModelLibraryModelsQuotesQuoteModel, options?: RawAxiosRequestConfig) {
        return QuoteApiFp(this.configuration).quoteUpdateQuote(quoteId, gmModelLibraryModelsQuotesQuoteModel, options).then((request) => request(this.axios, this.basePath));
    }
}

